import { render, staticRenderFns } from "./additionalnewservice.vue?vue&type=template&id=4c8b2264&scoped=true&"
import script from "./additionalnewservice.vue?vue&type=script&lang=js&"
export * from "./additionalnewservice.vue?vue&type=script&lang=js&"
import style0 from "./additionalnewservice.vue?vue&type=style&index=0&id=4c8b2264&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b2264",
  null
  
)

export default component.exports